/**
 * F09 v2 — the signed-in admin's verification permissions:
 *   read   = queue / detail (no documents) / candidates / watchlist / QA / entity
 *   review = decide, more-info, revoke, lift/unlock, invite, dismiss, resolve,
 *            document view + access log
 *   issue  = direct verify (super_admin)
 */
import { useAuth } from '../auth/useAuth';

export interface VerificationPermissions {
  readonly canRead: boolean;
  readonly canReview: boolean;
  readonly canIssue: boolean;
  readonly adminId: string | null;
}

/** `verifications:read` / `:review` / `:issue_privileged` for the signed-in admin. */
export function useVerificationPermissions(): VerificationPermissions {
  const { adminUser } = useAuth();
  const perms = adminUser?.permissions ?? [];
  return {
    canRead: perms.includes('verifications:read'),
    canReview: perms.includes('verifications:review'),
    canIssue: perms.includes('verifications:issue_privileged'),
    adminId: adminUser?.id ?? null,
  };
}
